import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const BUYERS = [{
  name: 'María G.',
  location: 'Ciudad de México'
}, {
  name: 'Carlos R.',
  location: 'Bogotá'
}, {
  name: 'Ana L.',
  location: 'Madrid'
}, {
  name: 'James W.',
  location: 'New York'
}, {
  name: 'Sofía M.',
  location: 'Buenos Aires'
}, {
  name: 'David P.',
  location: 'Miami'
}, {
  name: 'Laura T.',
  location: 'Barcelona'
}, {
  name: 'Roberto S.',
  location: 'Lima'
}, {
  name: 'Elena K.',
  location: 'London'
}, {
  name: 'Miguel A.',
  location: 'Santiago'
}, {
  name: 'Patricia H.',
  location: 'Toronto'
}, {
  name: 'Andrés F.',
  location: 'Medellín'
}, {
  name: 'Isabella V.',
  location: 'São Paulo'
}, {
  name: 'John D.',
  location: 'Los Angeles'
}, {
  name: 'Carmen B.',
  location: 'Monterrey'
}];
function getRandomInterval() {
  return Math.floor(Math.random() * 15000) + 25000; // 25–40 seconds
}
function getTimeAgo() {
  const mins = Math.floor(Math.random() * 12) + 1;
  return `${mins} min ago`;
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  const [timeAgo, setTimeAgo] = useState('');
  const [usedIndices, setUsedIndices] = useState<number[]>([]);
  const showNotification = useCallback(() => {
    let index: number;
    if (usedIndices.length >= BUYERS.length) {
      setUsedIndices([]);
      index = Math.floor(Math.random() * BUYERS.length);
    } else {
      do {
        index = Math.floor(Math.random() * BUYERS.length);
      } while (usedIndices.includes(index));
    }
    setUsedIndices(prev => [...prev, index]);
    setCurrentBuyer(BUYERS[index]);
    setTimeAgo(getTimeAgo());
    setVisible(true);
    setTimeout(() => setVisible(false), 4500);
  }, [usedIndices]);
  useEffect(() => {
    // First notification after 12 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 12000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!visible) {
      const nextTimeout = setTimeout(() => {
        showNotification();
      }, getRandomInterval());
      return () => clearTimeout(nextTimeout);
    }
  }, [visible, showNotification]);
  return <AnimatePresence data-id="element-615">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 60,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.5,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className="fixed bottom-6 left-6 z-50 max-w-xs" data-id="element-616">
          <div className="bg-surface border border-border-accent/40 rounded-sm p-4 shadow-[0_8px_32px_rgba(0,0,0,0.5),0_0_16px_rgba(201,168,76,0.1)] relative overflow-hidden" data-id="element-617">
            {/* Gold accent line */}
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-gold" data-id="element-618" />

            <div className="flex items-start gap-3" data-id="element-619">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent-primary/15 border border-accent-primary/30 flex items-center justify-center" data-id="element-620">
                <ShoppingBag className="w-4 h-4 text-accent-primary" data-id="element-621" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-622">
                <p className="font-ui text-sm text-text-primary font-medium leading-snug" data-id="element-623">
                  {currentBuyer.name}{' '}
                  <span className="text-text-secondary font-normal" data-id="element-624">from</span>{' '}
                  {currentBuyer.location}
                </p>
                <p className="font-ui text-xs text-accent-primary font-semibold mt-0.5" data-id="element-625">
                  just got the Complete Collection
                </p>
                <p className="font-ui text-[10px] text-text-muted mt-1 tracking-wide" data-id="element-626">
                  {timeAgo}
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}